import * as Dropbox from "dropbox";
const ACCESS_TOKEN = `${process.env.REACT_APP_ACCESS_TOKEN_DROPBOX}`;
const dbx = new Dropbox.Dropbox({ accessToken: ACCESS_TOKEN });
const URL_ORIGEN = window.location.href;

const API_SERVER = `${process.env.REACT_APP_API_SERVER}`;

export { API_SERVER, dbx, ACCESS_TOKEN, URL_ORIGEN };
